module.exports = __webpack_public_path__ + "img/hmm.2acafbfa.png";